var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3438 7.75C14.3438 7.90625 14.3438 8.03125 14.3438 8.1875C14.3438 12.5312 11.0625 17.5 5.03125 17.5C3.15625 17.5 1.4375 16.9688 0 16.0312C0.25 16.0625 0.5 16.0938 0.78125 16.0938C2.3125 16.0938 3.71875 15.5625 4.84375 14.6875C3.40625 14.6562 2.1875 13.7188 1.78125 12.4062C2 12.4375 2.1875 12.4688 2.40625 12.4688C2.6875 12.4688 3 12.4062 3.25 12.3438C1.75 12.0312 0.625 10.7188 0.625 9.125V9.09375C1.0625 9.34375 1.59375 9.46875 2.125 9.5C1.21875 8.90625 0.65625 7.90625 0.65625 6.78125C0.65625 6.15625 0.8125 5.59375 1.09375 5.125C2.71875 7.09375 5.15625 8.40625 7.875 8.5625C7.8125 8.3125 7.78125 8.0625 7.78125 7.8125C7.78125 6 9.25 4.53125 11.0625 4.53125C12 4.53125 12.8438 4.90625 13.4688 5.5625C14.1875 5.40625 14.9062 5.125 15.5312 4.75C15.2812 5.53125 14.7812 6.15625 14.0938 6.5625C14.75 6.5 15.4062 6.3125 15.9688 6.0625C15.5312 6.71875 14.9688 7.28125 14.3438 7.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.522b6ae65c796a3df318b5b77f54fcb6.svg";
export { ForwardRef as ReactComponent };